import React, { useCallback } from 'react';
import * as _ from '@ts/const';
import ImgPicuter from '@components/img-picture';
import { sendGtag } from '@ts/modules/sendgtag';
const ColumnItem = ({ columnItem }) => {
    const handleClick = useCallback(() => {
        const eventParams = {
            event_action: 'column',
            event_category: _.EVENT_CATEGORY,
            event_label: `[コラム]${columnItem.name}`
        };
        sendGtag(eventParams, _.IS_DEV);
    }, [
        columnItem
    ]);
    return (React.createElement("div", { className: "column-item" },
        React.createElement("div", { className: "column-item-image" },
            React.createElement("a", { href: columnItem.url, target: "_blank", onClick: handleClick },
                React.createElement(ImgPicuter, { fileName: `./assets/img/column-item/${columnItem.image_name}`, alt: columnItem.name, ext: 'jpg' }))),
        React.createElement("div", { className: "column-item-name" },
            React.createElement("a", { href: columnItem.url, target: "_blank", "data-label-hover": "\u30B3\u30E9\u30E0\u3092\u8AAD\u3080", onClick: handleClick }, columnItem.name))));
};
export default ColumnItem;
